var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,0h-6C9.3457031,0,8,1.3457031,8,3v42c0,1.6542969,1.3457031,3,3,3h6c1.6542969,0,3-1.3457031,3-3V3 C20,1.3457031,18.6542969,0,17,0z M18,45c0,0.5517578-0.4487305,1-1,1h-6c-0.5512695,0-1-0.4482422-1-1V3 c0-0.5517578,0.4487305-1,1-1h6c0.5512695,0,1,0.4482422,1,1V45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,0h-6c-1.6542969,0-3,1.3457031-3,3v42c0,1.6542969,1.3457031,3,3,3h6c1.6542969,0,3-1.3457031,3-3V3 C40,1.3457031,38.6542969,0,37,0z M38,45c0,0.5517578-0.4487305,1-1,1h-6c-0.5512695,0-1-0.4482422-1-1V3 c0-0.5517578,0.4487305-1,1-1h6c0.5512695,0,1,0.4482422,1,1V45z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseMedium);
export default __webpack_public_path__ + "static/media/pause--medium.9174f2fc4515d932d57ceee20b7bf1a2.svg";
export { ForwardRef as ReactComponent };